import { render, staticRenderFns } from "./LawLeaderDeptConfirm.vue?vue&type=template&id=23f891f1&"
import script from "./LawLeaderDeptConfirm.vue?vue&type=script&lang=js&"
export * from "./LawLeaderDeptConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports